import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";
import { useState } from "react";

import Home from "./pages/Home";
import About from "./pages/About";
import Contact from "./pages/Contact";
import Login from "./pages/Login";
import ProtectedRoute from "./components/ProtectedRoute";
import ByDate from "./pages/ByDate";
import Users from "./pages/Users";
import User from "./pages/User";
import ByDateAll from "./pages/ByDateAll";

function App() {
  const [isAuth, setIsAuth] = useState(false);
  const isAuthFromStorage = localStorage.getItem("jwt") ? true : false;

  // Ako postoji token u localStorage, postavi isAuth na true
  if (isAuthFromStorage && !isAuth) {
    setIsAuth(true);
  }

  return (
    <Router>
      <div>

        {/* Ako želiš logout dugme */}
        {/* {isAuth && (
          <button onClick={() => localStorage.removeItem("jwt")}>
            Logout
          </button>
        )} */}
        <Routes>
          {/* LOGIN */}
          <Route path="/login" element={<Login setIsAuth={setIsAuth} />} />

          {/* ZAŠTIĆENE STRANICE */}
          <Route
            path="/"
            element={
              <ProtectedRoute >
                <Home />
              </ProtectedRoute>
            }
          />
          <Route
            path="/users"
            element={
              <ProtectedRoute >
                <Users />
              </ProtectedRoute>
            }
          />
          <Route
            path="/by-date-all"
            element={
              <ProtectedRoute >
                <ByDateAll />
              </ProtectedRoute>
            }
          />
          <Route
            path="/about"
            element={
              <ProtectedRoute >
                <About />
              </ProtectedRoute>
            }
          />

          <Route
            path="/contact"
            element={
              <ProtectedRoute >
                <Contact />
              </ProtectedRoute>
            }
          />
          <Route
            path="/date/:date"
            element={
              <ProtectedRoute >
                <ByDate />
              </ProtectedRoute>
            }
          />
          <Route
            path="/user/:id"
            element={
              <ProtectedRoute >
                <User />
              </ProtectedRoute>
            }
          />
        </Routes>

      </div>
    </Router>
  );
}

export default App;